import React, { PropsWithChildren, ReactNode } from 'react'
import './MainMessage.scss'

export interface MainMessageProps extends PropsWithChildren {
    title: string;
    summary?: string;
}

export default function MainMessage(props: MainMessageProps) {
    return (
        <div className='main-message'>
            <sp-popover open dialog>
                <div flex-layout-column='' flex-gap-xl=''>
                    <sp-illustrated-message heading={props.title} description={props.summary}>
                        <t-logo compact></t-logo>
                    </sp-illustrated-message>
                    {props.children}
                </div>
            </sp-popover>
        </div>
    )
}
